"use client";

import React from "react";
import { Tabs, TabsContent, TabsList } from "../shadcn/Tabs";

const EventDetailsSkeleton = () => {
    return (
        <div
            className={`
            relative mt-4
            grid min-h-screen w-[95vw]
            max-w-[650px] animate-pulse
            grid-cols-1 items-start justify-center gap-12 lg:w-full
            lg:max-w-[95vw] lg:grid-cols-5 lg:flex-row`}
        >
            <div className="col-span-3 h-full w-full gap-5">
                <div className="relative h-[325px] w-full min-w-[200px] rounded-[4px] bg-gray-200"></div>
                <div className="hidden max-h-[200px] w-full flex-wrap gap-2 truncate md:flex">
                    {/* Placeholder for tags */}
                </div>
                <div className="flex h-full w-full flex-col gap-5 md:gap-3">
                    <div className="flex w-full">
                        <div className="h-8 w-full bg-gray-200"></div>{" "}
                        {/* Placeholder for title */}
                    </div>
                    <div className="h-16 w-full bg-gray-200 md:flex"></div>{" "}
                    {/* Placeholder for description */}
                    <div className="mt-6 flex h-full w-full flex-col gap-8">
                        <div className="flex h-16 w-full flex-col gap-2 bg-gray-200"></div>{" "}
                        {/* Placeholder for hosted by */}
                        <div className="h-8 w-full bg-gray-200"></div>{" "}
                        {/* Placeholder for price */}
                        <div className="h-8 w-full bg-gray-200"></div>{" "}
                        {/* Placeholder for capacity */}
                        <div className="h-16 w-full bg-gray-200"></div>{" "}
                        {/* Placeholder for attendees list */}
                    </div>
                </div>
            </div>

            <div className="col-span-2 flex h-full w-full flex-1 flex-col gap-10">
                <div className="relative flex h-8 w-full justify-between bg-gray-200"></div>{" "}
                {/* Placeholder for date */}
                <div className="flex h-16 w-full flex-col gap-2 bg-gray-200 uppercase"></div>{" "}
                {/* Placeholder for location */}
                <div className="flex h-16 w-full gap-4 bg-gray-200"></div>{" "}
                {/* Placeholder for time */}
                <div className="h-16 w-full bg-gray-200"></div>{" "}
                {/* Placeholder for RSVP controls */}
                <div className="h-16 w-full bg-gray-200"></div>{" "}
                <div className="h-16 w-full bg-gray-200"></div>{" "}
                <Tabs>
                    <TabsList className="grid h-12 w-full auto-cols-fr grid-flow-col bg-gray-200">
                        {/* Placeholder for tab triggers */}
                    </TabsList>
                    <TabsContent
                        className="h-32 w-full bg-gray-200"
                        value=""
                    ></TabsContent>{" "}
                    {/* Placeholder for tab content */}
                </Tabs>
            </div>
        </div>
    );
};

export default EventDetailsSkeleton;
